import OlsBrowseOntologiesView from '@/views/OlsBrowseOntologiesView.vue'
import OlsOntologyImportFormView from '@/views/OlsOntologyImportFormView.vue'
import OlsTermSearchView from '@/views/OlsTermSearchView.vue'

const ontologyRoutes = [
  {
    path: '/vocabularies/ontologies/browse-ols',
    component: OlsBrowseOntologiesView,
    name: 'olsBrowseOntologies',
  },
  {
    path: '/vocabularies/ontologies/import-from-ols',
    component: OlsOntologyImportFormView,
    name: 'olsOntologyImport',
  },
  {
    path: '/vocabularies/ontologyterms/search-ols',
    component: OlsTermSearchView,
    name: 'olsTermSearch',
  },
]

export default ontologyRoutes
